<template>
    <div class="index_main">
        <div class="index_mod5 index_mod6">
      <img
        src="../../assets/images/index_aboutbg.png"
        class="index_mod5bg index_mod6bg"
      />
      <div
        class="index_mod4con animated"
      >
        <div class="index_mod5text">
          <div class="flex_ali">
            <img src="../../assets/images/logo.png" class="index_mod5icon" />
            <h1>配音小程序</h1>
          </div>
          <p class="index_mod5info">
            配音小程序是以互联网为平台的专业网络配音服务机构，致力于为用户打造一站式配音新体验。配音小程序重点推出语音合成配音工具，“文字转换声音，一键获取音频”，制作简单、高效；同时提供人工配音服务，以一线配音师水平为准线建立配音团队，为用户制定个性化配音，旨在为用户提供优质的配音服务。
          </p>
          <div class="flex_ali">
            <div>
              <div class="index_mod5btn">
                <img src="../../assets/images/index_android.png" />
                <span>Android 下载</span>
              </div>
              <div class="index_mod5btn" @click="downIos">
                <img src="../../assets/images/index_iphone.png" />
                <span>iphone 下载</span>
              </div>
            </div>
            <div class="index_mod5code">
              <img src="../../assets/images/index_code.png" class="index_mod5bg" />
              <div class="index_mod5codecon">
                <img src="../../assets/images/appcode/appcode.png" />
                <p>手机扫码下载</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
    </div>
</template>
<script>
import Footer from "../../components/footer.vue";
export default({
  components: {
    Footer,
  },  
  methods:{
    downIos(){
      this.$message('暂未开放');
    },
  }
})
</script>


// WEBPACK FOOTER //
// src/view/aboutUs/downapp.vue